
TPS.Login = {
    init: function () {
        this.Idme.init();
    },
    overlayFadeIn: function (selector) {
        var targetElem = jQuery(selector);
        if (targetElem.length > 0 && !TPS.Util.checkActive(selector, 'active')) {

            var isVisible = Foundation.Box.ImNotTouchingYou(targetElem);
            if (Foundation.Box.ImNotTouchingYou(targetElem)) {
                targetElem.addClass('active');
            } else {
                jQuery(window).on('scroll', doFadeIn);
            }

            function doFadeIn(e) {

                if (Foundation.Box.ImNotTouchingYou(targetElem)) {
                    targetElem.addClass('active');
                    jQuery(window).off('scroll', doFadeIn);
                }

            }

        }

    },
}

TPS.Login.Idme = {
    init: function () {
        $(document).on('click', '.button-idme', function (e) {
            $('.idme-trigger-link').trigger('click');
        });
    },
}
